const baseStyle = () => ({
  bgColor: 'gray.50',
  borderRadius: 'sm',
  padding: 1,
  space: 1,
  width: '100%',

  _buttonActive: {
    bgColor: 'white',
    flex: 1,
    shadow: 0,
    _text: {
      color: 'darkText',
      fontWeight: 'bold',
      lineHeight: 'md',
    },
    _hover: {
      bgColor: 'gray.50',
    },
    _disabled: {
      _text: {
        color: 'gray.500',
      },
    },
  },
  _buttonInactive: {
    bgColor: 'transparent',
    flex: 1,
    _text: {
      color: 'darkText',
      lineHeight: 'md',
    },
    _hover: {
      bgColor: 'gray.100',
    },
    _disabled: {
      bgColor: 'gray.50',
      _text: {
        color: 'gray.500',
      },
    },
  },
});

export default {
  baseStyle,
};
